import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from "../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter";
import {ReportComponentDefinitionModel} from "../../../api/entity/reportComponentDefinition.model";
import {ReportComponentDefinitionDataService} from "./reportComponentDefinitionData.service";
import {ReportComponentDefinitionConverter} from "../../../api/entity/converter/reportComponentDefinition.converter";

@Injectable()
export class ReportComponentDefinitionDataServiceAdapter extends AbstractDataServiceDtoAdapter<ReportComponentDefinitionModel, ReportComponentDefinitionConverter> {
    constructor(dataService: ReportComponentDefinitionDataService, converter: ReportComponentDefinitionConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): ReportComponentDefinitionModel {
        return new ReportComponentDefinitionModel();
    }


}
